import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { O5_DEPLOYMENT_BASE_PATH } from '../../../../../../features/o5/deployment/o5-deployment-routing';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/deployment/_deployment')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-deployment-list',
        label: 'Deployments',
        to: O5_DEPLOYMENT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
